import { Pipe, PipeTransform } from '@angular/core';
import { LANG_COUNTRY } from '../constants/constants';
import { LocalStorageService } from '../services/localstorage.service';
import { UtilityService } from '../services/utility_functions/utility_functions.service';

@Pipe({
  name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {
  constructor(
    private _localStorageService: LocalStorageService,
    private utilityService: UtilityService,
  ){}
  transform(value: number, type?: string, module?: string,showInMillions: boolean = false): any {
    let countryCode = 'en-US';
    let country = 'US';
    let currency = 'USD';

    const company = this._localStorageService.getLocalStorage('company');
    if(company?.company_country){
      country = company?.company_country;
    }

    if(company?.company_currency){
      currency = company?.company_currency;
    }

    if(country){
      const code = LANG_COUNTRY;
      countryCode = code.data[country] ?? 'en-US';
    }

    if (showInMillions && value >= 1000000) {
      return `${(value / 1000000).toFixed(1)}M`;
    }

    if ((value >= 0) || (type === 'selling-price')){
      let config: any = {
        style: 'currency',
        currency: currency || 'USD'
      };
      if((module === 'ACCOUNTS') && (this.utilityService?.companyConfig?.taxation?.is_enabled === true)){
        let decimalNumbersLength: number;
        const decimalPointIndex = value.toString().indexOf('.');
        if(decimalPointIndex !== -1){
          decimalNumbersLength = value.toString().substring(decimalPointIndex+1).length;
        }else{
          decimalNumbersLength = 0;
        }
        config = {
          ...config,
          minimumFractionDigits: decimalNumbersLength,
          maximumFractionDigits: decimalNumbersLength,
        };
      }else{
        config = {
          ...config,
          minimumFractionDigits: this.utilityService.getCurrencyDecimal(),
          maximumFractionDigits: this.utilityService.getCurrencyDecimal(),
        };
      }
      
      let formatter: any;

      if (currency === 'SGD') {
        formatter  = new Intl.NumberFormat(countryCode, {
                      style: 'decimal',
                    });
        return 'S$' + formatter.format(Number(value))
      }
      else 
      {
        formatter =  new Intl.NumberFormat(countryCode, config);
      }

      return value === undefined ? '---' : formatter.format(value);
    }
  }

}
